import { ActionButton } from './icp-onboarding.model';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'icp-onboarding',
  templateUrl: './icp-onboarding.component.html',
  styleUrls: ['./icp-onboarding.component.scss'],
})
export class IcpOnboardingComponent {
  @Input() mobileFullScreen: boolean;

  @Input() actions?: ActionButton[] = [];
  @Input('at-bottom') atBottom?: boolean;
  @Input() disabled?: boolean;

  @Output() onClickButton?: EventEmitter<void> = new EventEmitter();

  constructor() {}

  onClick() {
    if (!this.disabled) {
      this.onClickButton.emit();
    }
  }

  onButtonClick(callback) {
    if (callback) {
      callback();
    }
  }
}
